import React from 'react';

const SaplingTransparent = (props) => (
  <svg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 121.4 133.1' {...props}>
    <defs>
      <linearGradient id='linear-gradient' x1={56.8} y1={46.88} x2={97.29} y2={12.91} gradientUnits='userSpaceOnUse'>
        <stop offset={0} stopColor='#7e28b2' />
        <stop offset={0.28} stopColor='#a71aa0' />
        <stop offset={0.6} stopColor='#cf0c8f' />
        <stop offset={0.85} stopColor='#e70484' />
        <stop offset={1} stopColor='#f00180' />
      </linearGradient>
      <linearGradient
        id='linear-gradient-2'
        x1={110.44}
        y1={97.34}
        x2={20.68}
        y2={45.51}
        gradientUnits='userSpaceOnUse'
      >
        <stop offset={0} stopColor='#9f37f4' />
        <stop offset={0.6} stopColor='#28a4d3' />
        <stop offset={1} stopColor='#18d0cc' />
      </linearGradient>
      <style>{'.cls-2{fill:#00a099}'}</style>
    </defs>
    <path
      style={{
        fill: 'none',
      }}
      d='M-5.9 2.65h32v32h-32z'
    />
    <path
      className='cls-2'
      d='M13.31 71.75c-.1-.5-.18-1-.26-1.52.08.51.16 1.02.26 1.52ZM13.08 62.16c.11-.65.23-1.3.39-1.94-.15.64-.28 1.29-.39 1.94ZM14.26 57.51ZM13.57 59.81ZM12.93 69.35c-.07-.54-.1-1.09-.13-1.64.03.55.06 1.1.13 1.64ZM12.81 64.54c0-.62.11-1.24.2-1.86-.09.62-.16 1.24-.2 1.86ZM12.76 67v-1.77c0 .54-.01 1.13 0 1.77ZM15.84 78.72c-.19-.36-.36-.74-.53-1.11.17.39.34.75.53 1.11ZM13.93 74.13c-.14-.46-.26-.93-.38-1.39.12.46.23.93.38 1.39ZM14.77 76.45c-.17-.41-.32-.83-.47-1.25.15.42.3.8.47 1.25ZM17.63 51a23.65 23.65 0 0 1 1.54-2 23.65 23.65 0 0 0-1.54 2ZM17.14 80.9c-.2-.31-.38-.63-.57-.94.19.31.37.63.57.94Z'
    />
    <path
      d='M56.64 46.66c.37.33.74.64 1.1 1L76.38 66.3 95 47.66a26.38 26.38 0 0 0 0-37.29 26.36 26.36 0 0 0-37.29 0l-.11.11a26.34 26.34 0 0 0-.96 36.18Z'
      style={{
        fill: 'url(#linear-gradient)',
      }}
    />
    <path
      className='cls-2'
      d='M18.68 83c-.19-.23-.35-.48-.53-.71.18.21.34.46.53.71ZM15.17 55.28c.32-.69.67-1.38 1-2.05-.33.67-.68 1.35-1 2.05ZM16.29 53.11ZM13.55 72.74c-.08-.33-.17-.66-.24-1 .07.34.16.67.24 1ZM15.31 77.61c-.19-.38-.38-.76-.54-1.16.16.4.35.78.54 1.16ZM18.15 82.27c-.35-.45-.7-.9-1-1.37.3.47.65.92 1 1.37ZM14.3 75.2c-.12-.35-.26-.71-.37-1.07.07.36.25.72.37 1.07ZM16.57 80c-.25-.41-.51-.82-.73-1.24.22.38.48.79.73 1.24ZM17.58 51.1l.05-.06ZM16.22 53.23a1.27 1.27 0 0 0 .07-.12 1.27 1.27 0 0 1-.07.12ZM15.08 55.48l.09-.2ZM14.16 57.81c0-.1.07-.2.1-.3-.03.1-.07.2-.1.3ZM13.47 60.22c0-.14.06-.27.1-.41-.04.19-.07.27-.1.41ZM12.8 67.71v-.76c-.03.25-.02.5 0 .76ZM12.78 65.18v-.64ZM13.05 70.23c0-.29-.09-.58-.12-.88.07.3.07.59.12.88ZM13 62.68c0-.17.05-.35.07-.52-.02.17-.07.35-.07.52Z'
    />
    <path
      d='M95 84.94 76.38 66.3 57.74 47.66c-.36-.36-.73-.67-1.1-1a26.34 26.34 0 0 1 1-36.18L20.45 47.66c-.45.45-.87.94-1.28 1.42a23.65 23.65 0 0 0-1.54 2l-.05.06c-.46.65-.89 1.33-1.29 2a1.27 1.27 0 0 1-.07.12c-.38.67-.73 1.36-1 2.05l-.09.2c-.3.67-.57 1.35-.82 2 0 .1-.07.2-.1.3-.23.66-.42 1.33-.59 2 0 .14-.07.27-.1.41-.16.64-.28 1.29-.39 1.94 0 .17-.05.35-.07.52-.09.62-.15 1.24-.2 1.86v3.17c0 .55.06 1.1.13 1.64 0 .3.08.59.12.88.08.51.16 1 .26 1.52.07.33.16.66.24 1s.24.93.38 1.39.25.72.37 1.07.3.84.47 1.25.35.78.54 1.16.34.75.53 1.11.48.83.73 1.24.37.63.57.94c.31.47.66.92 1 1.37.18.23.34.48.53.71a25 25 0 0 0 1.77 2l37.29 37.29a26.36 26.36 0 0 0 37.29 0A26.38 26.38 0 0 0 95 84.94Z'
      style={{
        fill: 'url(#linear-gradient-2)',
      }}
    />
  </svg>
);

export default SaplingTransparent;
